export const productInformationArray: Record<string, string[]> = {
  "st-ot": [
    "payment-information.list.0",
    "payment-information.list.2",
    "payment-information.list.3",
  ],
  "tr-ot": [
    "payment-information.list.0",
    "payment-information.list.2",
    "payment-information.list.3",
  ],
  st: [
    "payment-information.list.0",
    "payment-information.list.1",
    "payment-information.list.3",
  ],
  tr: [
    "payment-information.list.0",
    "payment-information.list.1",
    "payment-information.list.3",
  ],
  mt: [
    "payment-information.list.0",
    "payment-information.list.1",
    "payment-information.list.3",
  ],
  fhl: [
    "payment-information.fhl.list.0",
    "payment-information.fhl.list.1",
    "payment-information.fhl.list.2",
  ],
  bc: [
    "payment-information.bc.list.0",
    "payment-information.bc.list.1",
    "payment-information.bc.list.2",
  ],
  "bc-ot": [
    "payment-information.bc-ot.list.0",
    "payment-information.bc-ot.list.1",
    "payment-information.bc-ot.list.2",
  ],
  "mhl-ot": [
    "payment-information.mhl-ot.list.0",
    "payment-information.mhl-ot.list.1",
    "payment-information.mhl-ot.list.2",
  ],
  "ed-ot": [
    "payment-information.ed-ot.list.0",
    "payment-information.ed-ot.list.1",
    "payment-information.ed-ot.list.2",
  ],
  "amh-ot": [
    "payment-information.amh-ot.list.0",
    "payment-information.amh-ot.list.1",
    "payment-information.amh-ot.list.2",
    "payment-information.amh-ot.list.3",
    "payment-information.amh-ot.list.4",
  ],
  "aa-ot": [
    "payment-information.aa-ot.list.0",
    "payment-information.aa-ot.list.1",
    "payment-information.aa-ot.list.2",
    "payment-information.aa-ot.list.3",
    "payment-information.aa-ot.list.4",
  ],
  "ac-ot": [
    "payment-information.ac-ot.list.0",
    "payment-information.ac-ot.list.1",
    "payment-information.ac-ot.list.2",
    "payment-information.ac-ot.list.3",
    "payment-information.ac-ot.list.4",
  ],
  "b-ot": [
    "payment-information.b-ot.list.0",
    "payment-information.b-ot.list.1",
    "payment-information.b-ot.list.2",
    "payment-information.b-ot.list.3",
  ],
  ec: [
    `payment-information.dashboard.ec.list.0`,
    `payment-information.dashboard.ec.list.1`,
    `payment-information.dashboard.ec.list.2`,
    `payment-information.dashboard.ec.list.3`,
  ],
  "ro-ot": [
    "payment-information.ro-ot.list.0",
    "payment-information.ro-ot.list.1",
    "payment-information.ro-ot.list.2",
    "payment-information.ro-ot.list.3",
    "payment-information.ro-ot.list.4",
  ],
  "bb-ot": [
    "payment-information.bb-ot.list.0",
    "payment-information.bb-ot.list.1",
    "payment-information.bb-ot.list.2",
    "payment-information.bb-ot.list.3",
    "payment-information.bb-ot.list.4",
  ],
  "sl-ot": [
    "payment-information.sl-ot.list.0",
    "payment-information.sl-ot.list.1",
    "payment-information.sl-ot.list.2",
    "payment-information.sl-ot.list.3",
    "payment-information.sl-ot.list.4",
  ],
  "iwl-ot": [
    "payment-information.iwl-ot.list.0",
    "payment-information.iwl-ot.list.1",
    "payment-information.iwl-ot.list.2",
  ],
  "wp-ot": [
    "payment-information.wp-ot.list.0",
    "payment-information.wp-ot.list.1",
    "payment-information.wp-ot.list.2",
  ],
  "os-ot": [
    "payment-information.os-ot.list.0",
    "payment-information.os-ot.list.1",
    "payment-information.os-ot.list.2",
  ],
  "db-ot": [
    "payment-information.db-ot.list.0",
    "payment-information.db-ot.list.1",
    "payment-information.db-ot.list.2",
    "payment-information.db-ot.list.3",
  ],
  "cv-ot": [
    "payment-information.cv-ot.list.0",
    "payment-information.cv-ot.list.1",
    "payment-information.cv-ot.list.2",
    "payment-information.cv-ot.list.3",
  ],
};
